import React from "react";
import CrossOutlineIcon from "../../../Assets/svgs/CrossOutlineIcon";

const ConversationSidebar = ({ conversation, handleClose, chatEndRef }) => {
  return (
    <div className="chatsWrap" style={{ height: "100%" }}>
      <div className="chatsWrap__head">
        <h1 className="title title--h4">Conversation History</h1>
        <div className="chatsWrap__head__action">
          <button className="btn p_0" onClick={handleClose}>
            <CrossOutlineIcon width="14" height="13" />
          </button>
        </div>
      </div>
      <div style={{ paddingBottom: 52 }} className="chatsWrap__body">
        {conversation?.map((message) => (
          <p
            className={`chatText ${
              message?.role == "user" ? "chatText--right" : ""
            }`}
          >
            <span className="chatText__value">{message?.content}</span>
          </p>
        ))}
        <div ref={chatEndRef} />
      </div>
    </div>
  );
};

export default ConversationSidebar;
